<template>
  <div
    class="lpu-schedule-skeleton"
    :class="isMobile ? 'lpu-schedule-skeleton_mobile' : 'lpu-schedule-skeleton_full'"
  >
    <v-skeleton-loader type="text@14" />
  </div>
</template>

<script>
export default {
  name: 'LpuScheduleSkeleton',
  data: () => ({
    isMobile: window.MOBILE_VERSION,
  }),
}
</script>

<style lang="scss">
@import '~www/themes/doctors/common/variables';

.lpu-schedule-skeleton {
  .v-skeleton-loader {
    display: flex;
    flex-wrap: wrap;
    min-width: 238px;

    &__text {
      flex: 0 1 41%;
      height: 20px;
      margin-bottom: 12px;
      border-radius: $border-radius-md;

      &:nth-last-child(-n+2) {
        margin-bottom: 0;
      }
    }
  }

  &_mobile .v-skeleton-loader__text:nth-child(odd) {
    margin-right: 11%;
  }

  &_full .v-skeleton-loader__text:nth-child(odd) {
    margin-right: 15%;
  }
}
</style>
